import { Component } from '@angular/core';

@Component({
  selector: 'app-general-correspondence',
  templateUrl: './general-correspondence.component.html',
  styleUrls: ['./general-correspondence.component.scss'],
})
export class GeneralCorrespondenceComponent {}
